import { useEffect, useState } from "react";
import { masterSupabase } from "../lib/supabase-master.js";

export const useUnits = () => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUnits = async () => {
      try {
        setLoading(true);
        const { data, error: supabaseError } = await masterSupabase
          .from("units")
          .select("*");

        if (supabaseError) {
          console.error("❌ Units load error:", supabaseError);
          setError(supabaseError);
        } else {
          setUnits(data || []);
          console.log("✅ Units loaded:", data?.length, "units");
        }
      } catch (err) {
        console.error("❌ Units load exception:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadUnits();
  }, []);

  return { units, loading, error };
};
